export default __webpack_public_path__ + "static/media/calci.6c3378ba.jpg";